var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import classNames from "classnames";
import React, { useMemo } from "react";
import { Image as ImageComp } from "./../../ui-components";
import { RICOS_DEFAULTS } from "../consts";
import ExpandIcon from "../icons/expand";
import styles from "../statics/styles/image-viewer.rtlignore-scss";
import { ImageContainer } from "./image-container";
import { useCustomWidthStyle } from "./use-custom-width-style";
import { useFallbackWidthStyle } from "./use-fallback-width-style";
import { useImageDimensions } from "./use-image-dimensions";
import { useImageSocialAttributes } from "./use-image-social-attributes";
const Image = ({
  dataUrl,
  node,
  className,
  config,
  helpers,
  isMobile,
  seoMode,
  imageClickActionConfig,
  expand,
  captionComponent,
  shouldLazyLoadImages
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const containerData = ((_a = node.imageData) == null ? void 0 : _a.containerData) || RICOS_DEFAULTS.containerData;
  const { image, altText } = node.imageData || {};
  const { src } = image || {};
  const disableDownload = ((_b = node.imageData) == null ? void 0 : _b.disableDownload) === true ? (e) => e.preventDefault() : void 0;
  const imageSource = useMemo(() => {
    if (dataUrl) {
      return dataUrl;
    }
    const { url, id } = src || {};
    if (url) {
      return url;
    }
    const { getImageUrl } = helpers != null ? helpers : {};
    if (getImageUrl && id) {
      return getImageUrl({ file_name: id });
    }
    return id;
  }, [
    dataUrl,
    (_e = (_d = (_c = node.imageData) == null ? void 0 : _c.image) == null ? void 0 : _d.src) == null ? void 0 : _e.url,
    (_h = (_g = (_f = node.imageData) == null ? void 0 : _f.image) == null ? void 0 : _g.src) == null ? void 0 : _h.id,
    helpers == null ? void 0 : helpers.getImageUrl
  ]);
  const { width, height } = useImageDimensions({
    src: imageSource,
    containerData,
    image
  });
  const fallbackWidthStyle = useFallbackWidthStyle({ containerData, isMobile });
  const customWidthStyle = useCustomWidthStyle({ containerData, isMobile, width });
  const socialAttributes = useImageSocialAttributes({
    config,
    src,
    width: image == null ? void 0 : image.width,
    height: image == null ? void 0 : image.height
  });
  const doDimensionsExist = width !== void 0 && height !== void 0;
  return /* @__PURE__ */ React.createElement(ImageContainer, __spreadProps(__spreadValues({}, imageClickActionConfig), { disableDownload }), doDimensionsExist && imageSource && /* @__PURE__ */ React.createElement(
    ImageComp,
    __spreadValues({
      id: (_l = (_k = (_j = (_i = node.imageData) == null ? void 0 : _i.image) == null ? void 0 : _j.src) == null ? void 0 : _k.id) != null ? _l : imageSource,
      containerId: node.id,
      displayMode: "fill",
      width,
      height,
      uri: (_p = (_o = (_n = (_m = node.imageData) == null ? void 0 : _m.image) == null ? void 0 : _n.src) == null ? void 0 : _o.id) != null ? _p : imageSource,
      alt: altText || "",
      containerProps: {
        className: classNames(styles.imageWrapper, styles.imageRatio, className, {
          [styles.pointer]: !!expand
        }),
        containerId: node.id,
        style: __spreadValues(__spreadValues({
          ["--dim-height"]: height,
          ["--dim-width"]: width
        }, fallbackWidthStyle), customWidthStyle)
      },
      imageStyles: {
        maxWidth: "100%"
      },
      socialAttrs: socialAttributes,
      isSEOBot: !!seoMode
    }, shouldLazyLoadImages ? {
      placeholderTransition: seoMode ? void 0 : "blur",
      shouldUseLQIP: (config == null ? void 0 : config.disableTransition) !== false
    } : {})
  ), !!expand && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.expandContainer,
      onClick: expand,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          expand(e);
        }
      },
      role: "button",
      tabIndex: 0
    },
    /* @__PURE__ */ React.createElement(ExpandIcon, { className: styles.expandIcon })
  ), captionComponent);
};
export {
  Image
};
//# sourceMappingURL=image.js.map
